import IconType from './iconType';

export default function ArrowLeft({ color = 'var(--icon-subdued)', width = 24, height = 24, ...rest }: IconType) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.2803 8.28033C10.5732 7.98744 10.5732 7.51256 10.2803 7.21967C9.9874 6.92678 9.5126 6.92678 9.2197 7.21967L5.2197 11.2197C4.9268 11.5126 4.9268 11.9874 5.2197 12.2803L9.2197 16.2803C9.5126 16.5732 9.9874 16.5732 10.2803 16.2803C10.5732 15.9874 10.5732 15.5126 10.2803 15.2197L7.5607 12.5H17.25C17.6642 12.5 18 12.1642 18 11.75C18 11.3358 17.6642 11 17.25 11H7.5607L10.2803 8.28033Z"
        fill={color}
      />
    </svg>
  );
}
